module.exports = __webpack_public_path__ + "img/cloudClass.fb523a0c.png";